module.exports = __webpack_public_path__ + "img/bg2.1f15e2c5.png";